import { render, staticRenderFns } from "./LabelVertical.vue?vue&type=template&id=0ed08f58&scoped=true&"
import script from "./LabelVertical.vue?vue&type=script&lang=js&"
export * from "./LabelVertical.vue?vue&type=script&lang=js&"
import style0 from "./LabelVertical.vue?vue&type=style&index=0&id=0ed08f58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed08f58",
  null
  
)

export default component.exports